import React from "react";

function Caret() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20.548"
      height="12.074"
      viewBox="0 0 20.548 12.074"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="vectorMask"
            d="M1187.308,2120.05l.742-.743a1.05,1.05,0,0,1,1.486,0l7.739,7.742,7.736-7.742a1.05,1.05,0,0,1,1.486,0l.743.743a1.053,1.053,0,0,1,0,1.487l-9.224,9.229a1.051,1.051,0,0,1-1.486,0l-9.222-9.229A1.05,1.05,0,0,1,1187.308,2120.05Z"
            transform="translate(-1187 -2119)"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_by_Caret"
        data-name="Mask by Caret"
        clipPath="url(#clip-path)"
      >
        <g
          id="Mask_by_Caret-2"
          data-name="Mask by Caret"
          transform="translate(-6.165 -10.28)"
        >
          <g id="Base_Color_White" data-name="Base/Color/White">
            <rect
              id="Base_Color_Blue"
              data-name="Base/Color/Blue"
              width="32.877"
              height="32.895"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Caret;
